<template>
  <div class="field">
    <div class="label">图片验证码</div>
    <div class="value">
      <input
        type="text"
        :value="value"
        @input="onInput"
        placeholder="请输入图片验证码"
      />
    </div>
    <div class="code">
      <img
        class="btn-img"
        :src="url"
        @click="onClick"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    url: String,
  },
  methods: {
    onInput(event) {
      this.$emit("input", event.target.value);
    },
    onClick() {
      this.$emit("refresh");
    }
  }
}
</script>

<style scoped>
input {
  text-align: left;
}
.btn-img {
  display: inline-block;
  height: 0.4rem;
  vertical-align: middle;
}
</style>